const FOOTER_COLUMNS = [
  {
    title: '内容分区',
    links: ['今日准点汇总', '大图卡片流', '准点时间线', '六点前线索', '六点刚出的事'],
  },
  {
    title: '互动',
    links: ['热评区', '吃瓜热榜', '话题标签', '评论区挖线索'],
  },
  {
    title: '关于',
    links: ['更新节奏说明', '内容来源标注', '纠错与补充', '联系我们'],
  },
];

export default function SiteFooter() {
  return (
    <footer className="w-full border-t border-background-200 bg-secondary-50">
      <div className="mx-auto w-full max-w-[1360px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr] lg:gap-10">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-600 text-background-50">
                <i className="ri-time-fill text-lg" />
              </span>
              <span className="font-heading text-lg font-black text-foreground-950">黑料六点</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-700">
              黑料六点每日准点跟进今天新瓜详情，六点前的瓜和六点刚出的事都集中放在同一条时间线上，评论区随时可以继续挖线索。
            </p>
            <div className="mt-5 flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-md border border-background-300 text-foreground-700">
                <i className="ri-wechat-line text-base" />
              </span>
              <span className="flex h-8 w-8 items-center justify-center rounded-md border border-background-300 text-foreground-700">
                <i className="ri-weibo-line text-base" />
              </span>
              <span className="flex h-8 w-8 items-center justify-center rounded-md border border-background-300 text-foreground-700">
                <i className="ri-rss-line text-base" />
              </span>
            </div>
          </div>

          {FOOTER_COLUMNS.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading text-sm font-bold tracking-wide text-foreground-950">
                {col.title}
              </h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((item) => (
                  <li key={item}>
                    <a
                      href="#hero"
                      className="cursor-pointer text-sm text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-300 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-600">
            © 2026 黑料六点 · 每日定时更新，今日六点准时见
          </p>
          <p className="text-xs text-foreground-600">
            内容均为网友讨论整理，仅供交流参考
          </p>
        </div>
      </div>
    </footer>
  );
}